var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "no-workspaces": _vm.workspaces === null || _vm.workspaces.length === 0,
        "workspaces-card": _vm.workspaces && _vm.workspaces.length > 0
      }
    },
    [
      _vm.workspaces === null
        ? _c("span", [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("GlobalSearchWorkspacesInstruction")) +
                "\n  "
            )
          ])
        : _vm.workspaces.length === 0
        ? _c("span", [_vm._v("\n    " + _vm._s(_vm.$t("NoResults")) + "\n  ")])
        : _vm.workspaces.length > 0
        ? _c(
            "div",
            { staticClass: "table-container" },
            [
              _c("span", { staticClass: "table-title" }, [
                _vm._v(_vm._s(_vm.$t("WorkspacesList")))
              ]),
              _vm._v(" "),
              _c("Table", {
                style: { width: "100%" },
                attrs: {
                  customButton: "",
                  loading: _vm.loading,
                  headers: _vm.headers,
                  items: _vm.workspaces,
                  sortable: true,
                  "scroll-id": _vm.scrollId
                },
                on: {
                  onScrollBottom: _vm.onScrollBottom,
                  onScrollTop: _vm.onScrollTop,
                  sortClick: _vm.onSortClick,
                  onRowClick: function($event) {
                    _vm.selectedWorkspace = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "customButton",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "button-container" },
                          [
                            _c("custom-button", {
                              attrs: {
                                label: _vm.$t("Go") + " >",
                                "button-color": "var(--app-primary-base)",
                                "label-color": "#FFF",
                                "button-styling": _vm.buttonStyling
                              },
                              on: {
                                buttonClick: function($event) {
                                  return _vm.openWorkspace()
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("loading-spinner", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2089e211", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2089e211","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/WorkspacesManagement/GlobalSearch/GlobalSearchWorkspaces.vue
// module id = null
// module chunks = 